import type { PickQueueOrder, TransferRow, WarehouseDashboard, WarehouseServices } from '../warehouseContracts';
import { api } from './client';

const W = '/api/warehouse';

function uiTransfer(status: string) {
  const s = status.toUpperCase();
  if (s === 'DISPATCHED') return 'dispatched';
  if (s === 'RECEIVED') return 'received';
  return 'draft';
}

export const httpWarehouseServices: WarehouseServices = {
  async dashboard(): Promise<WarehouseDashboard> {
    const me = await api<{ warehouse: { name: string } }>(`${W}/me`);
    const dash = await api<Omit<WarehouseDashboard, 'name'>>(`${W}/dashboard`);
    return { name: me.warehouse.name, ...dash };
  },
  async queue() {
    const page = await api<{ items: PickQueueOrder[] }>(`${W}/queue`);
    return page.items ?? [];
  },
  async advance(orderId) {
    await api(`${W}/queue/${orderId}/advance`, { method: 'POST', body: '{}' });
  },
  async transfers() {
    const page = await api<{ items: (TransferRow & { status: string })[] }>(`${W}/transfers`);
    return (page.items ?? []).map((t) => ({ ...t, status: uiTransfer(t.status) }));
  },
  async locations() {
    const page = await api<{ items: { id: string; name: string }[] }>(`${W}/locations`);
    return page.items ?? [];
  },
  async createTransfer(input) {
    await api(`${W}/transfers`, { method: 'POST', body: JSON.stringify(input) });
  },
  async transferAction(id, status) {
    const map: Record<string, string> = { dispatched: 'DISPATCHED', received: 'RECEIVED' };
    await api(`${W}/transfers/${id}/action`, { method: 'POST', body: JSON.stringify({ status: map[status] ?? status }) });
  },
  async stock() {
    const page = await api<{ items: { id: string; name: string; sku: string; stock: number }[] }>(`${W}/stock`);
    return page.items ?? [];
  },
  async recordCount(productId, counted) {
    await api(`${W}/counts`, { method: 'POST', body: JSON.stringify({ productId, counted }) });
  },
};
